import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {AppBar, Toolbar, Typography} from '@material-ui/core';
import SignedInLinks from './SignedInLinks';
import {NavLink} from 'react-router-dom';


const Navbar = (props) => {
    const {classes} = props;

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Toolbar>
                    <Typography className={classes.grow} color="inherit" variant="h6">
                        <NavLink className={classes.resetLinkStyle} to="/">
                            <img alt={"NEMU Logo"} src={"images/logo-nemu-min.png"} style={{maxHeight: 25, marginRight: 5}}/>
                            <span>NEMU</span>
                        </NavLink>
                    </Typography>
                    <SignedInLinks style={classes}/>
                </Toolbar>
            </AppBar>
        </div>
    );
};

const styles = {
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20
    },
    resetLinkStyle: {
        textDecoration: 'none',
        color: 'white'
    },
    resetLinkStyleInMenu: {
        textDecoration: 'none',
        color: 'black'
    }
};
export default withStyles(styles)(Navbar);